import { render } from "./404View.vue?vue&type=template&id=710082c4&scoped=true"
import script from "./404View.vue?vue&type=script&lang=js"
export * from "./404View.vue?vue&type=script&lang=js"

import "./404View.vue?vue&type=style&index=0&id=710082c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710082c4"]])

export default __exports__